import {Component, DestroyRef, inject, OnInit, TemplateRef, ViewChild} from '@angular/core';
import { SelectOutletComponent } from '../../addcategory/select-outlet/select-outlet.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SupplierOutletService } from '../../app-shared/services/supplier-outlet.service';
import { NavigationStart, Router, RouterEvent } from '@angular/router';
import { filter, take } from 'rxjs';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
    selector: 'app-add-new-category-dialogs',
    templateUrl: './add-new-category-dialogs.component.html',
    styleUrls: ['./add-new-category-dialogs.component.scss'],
    standalone: false
})
export class AddNewCategoryDialogsComponent {
  @ViewChild('dialogBody') dialogBody: TemplateRef<SelectOutletComponent>;
  step: number;
  private dialogRef: MatDialogRef<any>;
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private dialog: MatDialog,
    private supplierOutletService: SupplierOutletService,
    private router: Router
  ) {}

  addNewCategoryClick() {
    this.supplierOutletService.removeSelectOutletForActivateCatalog();
    this.step = 1;
    this.dialogRef = this.dialog.open(this.dialogBody, {
      width: '510px',
      autoFocus: false,
      panelClass: 'newCategory-panel',
    });
    this.dialogRef.afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
      next: () => {},
    });
    this.router.events
      .pipe(
        take(1),
        filter((event): event is NavigationStart => event instanceof NavigationStart),
        filter(() => !!this.dialogRef)
      )
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.dialogRef.close();
      });
  }

  goNext() {
    this.step++;
    if (this.step > 3) {
      this.dialogRef.close();
    }
  }

  goPrev() {
    this.step--;
  }

  selectOutlet() {
    this.step = 1;
  }

  close() {
    this.dialogRef.close();
  }
}
